import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  labs: null,
  downloadInProgress: {},
};

const labListingSlice = createSlice({
  name: "labListing",
  initialState,
  reducers: {
    fetchLabs(state, action) {
      state.loading = true;
    },
    fetchLabsSuccess(state, action) {
      state.labs = action.payload.data.document;
      state.loading = false;
    },
    fetchLabsFailure(state, action) {
      state.loading = false;
    },
    downloadDocument(state, action) {
      state.downloadInProgress[action.payload.id] = true;
    },
    downloadDocumentSuccess(state, action) {
      state.downloadInProgress[action.payload.id] = false;
    },
    downloadDocumentFailure(state, action) {
      state.downloadInProgress[action.payload.id] = false;
    },

    addOrEditLabOperator(state, action) {},
    addOrEditLabOperatorSuccess(state, action) {},
    addOrEditLabOperatorFailure(state, action) {},
  },
});

export const { actions, reducer, name: sliceKey } = labListingSlice;
